/* eslint-disable */
import PropTypes from "prop-types";
import { useState, useEffect } from 'react';
import { MdDelete, MdModeEdit } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { Button,  Form, Input, Checkbox, Menu } from 'antd';
import DataTable from "../../../../../../../components/Layout/Table/DataTable";
import DeleteUserModal from "../../../../../../../components/Layout/DeleteModel/DeleteUserModal";
import CreateUpdateRentRoll from "../../CreateUpdateRentRoll";

function EditableCell({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) {
  const inputNode = inputType === 'number' ? <Input type={inputType} /> : <Input type={inputType} />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: false,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
function LeaseTerm({ sethideTableColumns, activeKey }) {
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');
  const [addUpdateNewRentRoll, setAddUpdateNewRentRoll] = useState(false);
  const [deleteUserModal, setDeleteUserModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [toggle, setToggle] = useState([]);
  
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const AddUpdateNewRentRollcloseModal = () => {
    setAddUpdateNewRentRoll(false);
  };
  const closeDeleteUserModal = () => {
    setDeleteUserModal(false);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.key);
  };

  const [dataSource, setDataSource] = useState([
    {
      key: 1,
      no: "1",
      pid: "01",
      status: "LET",
      start: "8/1/2013",
      end: " ",
      option1: " ",
      option2: " ",
      option3: " ",
    },
    {
      key: 2,
      no: "1",
      pid: "01",
      status: "LET",
      start: "5/1/2007",
      end: "4/30/2031",
      option1: " ",
      option2: " ",
      option3: " ",
    },
    {
      key: 3,
      no: "1",
      pid: "01",
      status: "LET",
      start: "1/1/1992",
      end: "4/30/2031",
      option1: " ",
      option2: " ",
      option3: " ",
    },
    {
      key: 4,
      no: "1",
      pid: "01",
      status: "LET",
      start: "5/1/2007",
      end: "4/30/2031",
      option1: " ",
      option2: " ",
      option3: " ",
    },
    {
      key: 5,
      no: "1",
      pid: "01",
      status: "LET",
      start: "10/1/2011",
      end: "4/30/2031",
      option1: " ",
      option2: " ",
      option3: " ",
    },
    {
      key: 6,
      no: "1",
      pid: "01",
      status: "LET",
      start: "10/1/2011",
      end: "26.26",
      option1: " ",
      option2: " ",
      option3: " ",
    },
    {
      key: 7,
      no: "1",
      pid: "01",
      status: "LET",
      start: "5/15/2013",
      end: " ",
      option1: " ",
      option2: " ",
      option3: " ",
    },
    {
      key: 8,
      no: "1",
      pid: "01",
      status: "LET",
      start: "9/1/2011",
      end: " ",
      option1: " ",
      option2: " ",
      option3: " ",
    },
    {
      key: 9,
      no: "1",
      pid: "01",
      status: "LET",
      start: "9/1/2011",
      end: " ",
      option1: " ",
      option2: " ",
      option3: " ",
    },
    {
      key: 10,
      no: "1",
      pid: "01",
      status: "LET",
      start: "5/1/2014",
      end: " ",
      option1: " ",
      option2: " ",
      option3: " ",
    },
    {
      key: 11,
      no: "1",
      pid: "01",
      status: "LET",
      start: "7/1/2013",
      end: "6/30/2025",
      option1: " ",
      option2: " ",
      option3: " ",
    },
    {
      key: 12,
      no: "1",
      pid: "01",
      status: "LET",
      start: "7/1/2013",
      end: "6/30/2025",
      option1: " ",
      option2: " ",
      option3: " ",
    },
  ]);

  const cancel = () => {
    setEditingKey('');
  };
  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setDataSource(newData);
        setEditingKey('');
      } else {
        newData.push(row);
        setDataSource(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const leaseTermColumns = [

    {
      id: 1,
      title: "PID",
      dataIndex: "pid",
      hidden: false,
    },
    {
      id: 2,
      title: "Status/Type",
      dataIndex: "status",
      hidden: false,
    },
    {
      id: 3,
      title: "Start",
      dataIndex: "start",
      hidden: toggle.includes("start"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "date",
        dataIndex: "start",
        title: "Start",
        editing: isEditing(record),
      }),
    },
    {
      id: 4,
      title: "End",
      dataIndex: "end",
      hidden: toggle.includes("end"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "date",
        dataIndex: "end",
        title: "End",
        editing: isEditing(record),
      }),
    },
    {
      id: 5,
      title: "Option 1",
      dataIndex: "option1",
      hidden: toggle.includes("option1"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "date",
        dataIndex: "option1",
        title: "Option 1",
        editing: isEditing(record),
      }),
    },
    {
      id: 6,
      title: "Option 2",
      dataIndex: "option2",
      hidden: toggle.includes("option2"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "date",
        dataIndex: "option2",
        title: "Option 2",
        editing: isEditing(record),
      }),
    },
    {
      id: 7,
      title: "Option 3",
      dataIndex: "option3",
      hidden: toggle.includes("option3"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "date",
        dataIndex: "option3",
        title: "Option 3",
        editing: isEditing(record),
      }),
    },
    {
      id: 10,
      title: "Action",
      dataIndex: "Action",
      hidden: false,
      width: "10%",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span className="d-flex align-items-center justify-content-center">
            <div
              role="presentation"
              className="m-0 mr-2 drawer-action-icons cursor-pointer"
              onClick={() => cancel()}
            >
              <MdDelete size={20} />
            </div>
            <div
              className="m-0 drawer-action-icons cursor-pointer"
              role="presentation"
              onClick={() => save(record.key)}
            >
              <FaCheck size={20} />
            </div>
          </span>
        ) : (
          <div className="d-flex align-items-center justify-content-center">
          <div
            className="drawer-action-icons d-flex align-items-center cursor-pointer"
            role="presentation"
            disabled={editingKey !== ""}
            onClick={() => edit(record)}
          >
            <MdModeEdit size={20} />
          </div>
          </div>
        );
      },
    },
  ];

  const handleReset = () => {
    setToggle([]);
  };
  const handleChange = (e) => {
    const checked = e.target.checked;
    const value = e.target.value;
    if(checked){
      setToggle((prev) => [...prev, value]);
    }
    else{
      setToggle((prev) => prev.filter((item) => item !== value));
    }
  };

  const basicDatahideTableColumns = (
    <Menu
      items={[
        {
          key: 1,
          type: "group",
          label: (
            <div>
              <h4 style={{ color: "#000" }}>Hide table columns</h4>
            </div>
          ),
        },
        // {
        //   key: 2,
        //   label: (
        //     <Checkbox
        //       value="status"
        //       name="Status/Type"
        //       id={2}
        //       // checked={checkList.includes("valDate")}
        //       // onChange={handleChange}
        //     >
        //       Status/Type
        //     </Checkbox>
        //   ),
        // },
        {
          key: 3,
          label: (
            <Checkbox
              value="start"
              name="Start"
              id={3}
              // checked={checkList.includes("projectNo")}
              onChange={handleChange}
            >
              Start
            </Checkbox>
          ),
        },
        {
          key: 4,
          label: (
            <Checkbox
              value="end"
              name="End"
              id={4}
              // checked={checkList.includes("projectName")}
              onChange={handleChange}
            >
              End
            </Checkbox>
          ),
        },
        {
          key: 5,
          label: (
            <Checkbox
              value="option1"
              name="Option 1"
              id={5}
              // checked={checkList.includes("nameOfClient1")}
              onChange={handleChange}
            >
              Option 1
            </Checkbox>
          ),
        },
        {
          key: 6,
          label: (
            <Checkbox
              value="option2"
              name="Option 2"
              id={6}
              // checked={checkList.includes("nameOfClient2")}
              onChange={handleChange}
            >
              Option 2
            </Checkbox>
          ),
        },
        {
          key: 7,
          label: (
            <Checkbox
              value="option3"
              name="Option 3"
              id={7}
              // checked={checkList.includes("instruction")}
              onChange={handleChange}
            >
              Option 3
            </Checkbox>
          ),
        },
        {
          key: 8,
          label: (
            <div>
              <hr style={{ border: "1px solid #F2F3F5" }} />
              <Button className="reset-dropdown-btn" onClick={handleReset}>
                Reset
              </Button>
            </div>
          ),
        },
      ]}
    />
  );

  useEffect(() => {
    sethideTableColumns(basicDatahideTableColumns)
  }, [activeKey]);
  return (
    <>
      <Form form={form} component={false}>
        <DataTable
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          rowClassName={() => "editable-row"}
          columns={leaseTermColumns.filter((item) => item.hidden === false)}
            dataSource={[...dataSource]}
          pagination="true"
          className="antd-table-striped"
          rowSelection={rowSelection}
        />
      </Form>
      <div className="table-count">
        <h5 className="table-count-content">Showing 1 to 9 of 120 entries</h5>
      </div>
      {/* <Row gutter={24}>
        <Col xs={24}>
          <div className="table-footer-btn d-flex align-items-center">
            <div className="align-items-center bg-white d-flex justify-content-between rounded-sm btn-action-div">
              <Button
                className="btn-action d-flex justify-content-center align-items-center text-danger"
                onClick={() => setDeleteUserModal(true)}
                disabled={selectedRowKeys?.length === 0 ? "true" : false}
              >
                <div className="active-action d-flex align-items-center">
                  <MdDelete />
                  <h5 className="mb-0 ml-1 mt-1 text-danger">Delete</h5>
                </div>
              </Button>

              {selectedRowKeys?.length > 1 ? (
                ""
              ) : (
                <>
                  <Divider type="vertical" />
                  <Button
                    className="btn-action d-flex justify-content-center align-items-center"
                    onClick={() => setAddUpdateNewRentRoll(true)}
                    disabled={selectedRowKeys?.length === 0 ? "true" : false}
                  >
                    <div className="active-action d-flex align-items-center">
                      <MdModeEdit className="mt-1" />
                      <h5 className="mb-0 ml-1 mt-1 ">Edit</h5>
                    </div>
                  </Button>
                </>
              )}
            </div>
          </div>
        </Col>
      </Row> */}
      <DeleteUserModal
        visible={deleteUserModal}
        handleCancel={closeDeleteUserModal}
        user="Asset"
      />
      <CreateUpdateRentRoll
        visible={addUpdateNewRentRoll}
        handleCancel={AddUpdateNewRentRollcloseModal}
      />
    </>
  );
}

export default LeaseTerm;

EditableCell.propTypes = {
  editing: PropTypes.node.isRequired,
  dataIndex: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  inputType: PropTypes.node.isRequired,
  record: PropTypes.node.isRequired,
  index: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};
LeaseTerm.propTypes = {
  sethideTableColumns: PropTypes.node.isRequired,
  activeKey: PropTypes.node.isRequired,
};